import React, { Component } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import NewsTicker from '../../components/ticker';
import { REACT_APP_API_BASE } from '../../config';
import withFetch from '../../hoc/withFetch';
import ChangeTerm from '../../components/report/change-term';
import Heading from '../../components/heading';
import { List } from '../../components/statistics';
import SpinnerDots from '../../components/spinner/dots';
import MarketAreas from '../../components/marketareas';
import './styles.scss';
class Statistics extends Component {
    
    state = {
        isLoading: true,
        companies: [],
        companyId: null,
        branches: [],
        news: []
    };

    async fetchNews() {
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/news?skip=0&take=3`);

        if(!res.ok) return {};
        
        const data = await res.json();
        
        return { 
            ...data
        };
    }
    

    async componentDidMount() {
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/reporting/companies`);
        if (!res.ok) {
            //handle 404
        }

        const companies = await res.json();

        const { news } = await this.fetchNews();
        
        this.setState({
            companies,
            news
        });

        const { match } = this.props;

        const companyId = companies.length === 1 ? companies[0].id : match.params.companyId;

        if (companyId) {
            const branches = await this.getBranches(companyId);
            this.setState({
                companyId,
                branches,
                isLoading: false
            });
        }
    }

    async getBranches(companyId) {
        //const res = await this.props.fetch(`${REACT_APP_API_BASE}/reporting/companies/${companyId}/branches`);
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/reporting/user/branches `);
        if (!res.ok) {
            //handle 404
        }

        return await res.json();

        
    }

    handleChange(e) {
        this.props.history.push(`/company/${e.target.value}`);
    }

    async componentDidUpdate(nextProps) {
        const { match } = this.props;

        if (match.params.companyId !== nextProps.match.params.companyId) {
            this.setState({
                isLoading: true
            });

            const branches = await this.getBranches(match.params.companyId);
            this.setState({
                companyId: match.params.companyId,
                branches,
                isLoading: false
            });
        }
    }

    render() {
        return (
            <section className={classNames({
                'statistics': true,
                'statistics--is-loading': this.state.isLoading
            })}>
                <NewsTicker isLoading={this.state.isLoading} news={this.state.news}/>
                <Heading heading="Statistik"  modifiers={{
                    'page-header--gray-bg': true
                }}>
                    {this.state.companies.length > 1 &&
                        <ChangeTerm onChange={(e) => this.handleChange(e)}>
                            <option>Välj företag</option>
                            {this.state.companies.map(company => {
                                return (
                                    <option key={company.id} value={company.id}>{company.name}</option>
                                );
                            })}
                        </ChangeTerm>
                    }
                </Heading>
                
                <List {...this.state} companyId={this.state.companyId} />
                
                <SpinnerDots />

                <MarketAreas heading="Dokument för statistik" />
                {/*<div className={classNames({
                    'spinner': true,
                    'spinner--is-loading': this.state.isLoading,
                    'spinner--fast': true,
                    'spinner--animate-up': true
                })}>
                    <Lottie 
                        options={{
                            loop: true,
                            autoplay: true,
                            animationData: loading,
                            rendererSettings: {
                                preserveAspectRatio: "xMidYMid slice"
                            }}} 
                        height={200}
                        width={240} />
                        </div>*/}
            </section>
        );
    }
};

export default withRouter(withFetch(Statistics));